import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import UserLayout from "../components/UserLayout";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import {Box, Pagination} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {tr} from "date-fns/locale";
import {DateRangePicker} from "../components/DateRangePicker";
import {AppState} from "../store";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {getMailLogsAction} from "../api/appUser";
import moment from "moment";
import {NO_DATA} from "../shared/utils";

export default function MailLogs() {
    const dispatch: any = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get("page") || "1");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const mailLogs = useSelector((state: AppState) => state.appUser.mailLogs);
    const totalNumberPages = mailLogs?.totalNumberPages || 0;

    useEffect(() => {
        const params = {
            page,
            fromDate: startDate?.toISOString() || null,
            toDate: endDate?.toISOString() || null,
        };
        dispatch(getMailLogsAction(params));
    }, [dispatch, page, startDate, endDate]);

    const handleChangePage = (_: React.ChangeEvent<unknown>, value: number) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("page", value.toString());
        navigate(`?${searchParams.toString()}`);
    };

    const applyStartDateFilter = (date: Date | null) => {
        setStartDate(date);
        navigate("?page=1");
    };

    const applyEndDateFilter = (date: Date | null) => {
        setEndDate(date);
        navigate("?page=1");
    };

    return (
        <UserLayout>
            <div id="sidebar">
                <h1>E-POSTA KAYITLARI</h1>
                <Box sx={{overflowX: "auto"}}>
                    <Table sx={{minWidth: 800}} aria-label="mail log table">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                        <DateRangePicker
                                            startDate={startDate}
                                            endDate={endDate}
                                            applyStartDateFilter={applyStartDateFilter}
                                            applyEndDateFilter={applyEndDateFilter}/>
                                    </LocalizationProvider>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{width: {xs: "22%", md: "18%"}}}>KİMDEN</TableCell>
                                <TableCell sx={{width: {xs: "22%", md: "18%"}}}>KİME</TableCell>
                                <TableCell sx={{width: {xs: "40%", md: "50%"}}}>KONU</TableCell>
                                <TableCell sx={{width: {xs: "16%", md: "14%"}}}>OLUŞTURULMA TARİHİ</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {mailLogs?.entity.length ? (
                                mailLogs.entity.map((log) => (
                                    <TableRow key={log.id}>
                                        <TableCell>{log.mailFrom || NO_DATA}</TableCell>
                                        <TableCell>{log.mailTo || NO_DATA}</TableCell>
                                        <TableCell
                                            sx={{whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '200px'}}>
                                            {log.subject || NO_DATA}
                                        </TableCell>
                                        <TableCell>
                                            {log.createDate
                                                ? moment(log.createDate * 1000).format("YYYY-MM-DD HH:mm:ss")
                                                : NO_DATA}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        Veri bulunamadı
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
                {totalNumberPages > 1 && (
                    <div style={{display: "flex", justifyContent: "center", marginTop: "10px"}}>
                        <Pagination
                            page={page}
                            count={totalNumberPages}
                            defaultPage={1}
                            onChange={handleChangePage}/>
                    </div>
                )}
            </div>
        </UserLayout>
    );
}
